import { LoadingChip } from '@app/components/base/LoadingChip';
import { webApi } from '@mi-front/api-clients';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';

interface SocialExportUploadStatusChipProps {
  status: webApi.FragmentSocialUploadItemDtoStatusEnumKey | undefined;
}

/**
 * Renders a small Chip for the social export upload status (completed, scheduled, in progress, failed, cancelled).
 */
export function SocialExportUploadStatusChip({ status }: SocialExportUploadStatusChipProps) {
  const { formatMessage: $t } = useIntl();
  const statusEnum = webApi.FragmentSocialUploadItemDtoStatusEnum;

  if (!status) {
    return null;
  }

  if (status === statusEnum.COMPLETED) {
    return (
      <Chip
        size="small"
        color="success"
        label={
          $t({
            id: 'fragments.socialExport.videoPublishedSuccess',
            defaultMessage: 'Publicado',
          }) as string
        }
      />
    );
  }

  if (status === statusEnum.SCHEDULED) {
    return (
      <Chip
        size="small"
        color="info"
        label={
          $t({
            id: 'fragments.socialExport.scheduledChip',
            defaultMessage: 'Programado',
          }) as string
        }
      />
    );
  }

  if (
    status === statusEnum.WAITING ||
    status === statusEnum.WAITING_CHILDREN ||
    status === statusEnum.IN_PROGRESS
  ) {
    return (
      <LoadingChip
        label={
          $t({
            id: 'fragments.socialExport.inProgressChip',
            defaultMessage: 'En curso',
          }) as string
        }
      />
    );
  }

  if (status === statusEnum.FAILED) {
    return (
      <Chip
        size="small"
        color="error"
        label={
          $t({
            id: 'fragments.socialExport.errorChip',
            defaultMessage: 'Error',
          }) as string
        }
      />
    );
  }

  if (status === statusEnum.CANCELLED) {
    return (
      <Chip
        size="small"
        color="default"
        label={
          $t({
            id: 'fragments.socialExport.cancelledChip',
            defaultMessage: 'Cancelado',
          }) as string
        }
      />
    );
  }

  return null;
}
